<template>
  <ProfileLayout title="Account Settings">
    <template #sidebar>
      <ProfileSidebar :active-tab="activeTab" :client-role="currentClientRole" />
    </template>

    <template #main>
      <router-view @update-user="updateUserInfo" />
    </template>
  </ProfileLayout>
</template>

<script>
// Api
import { UserApi } from '@api/index';

// Store
import { mapGetters } from 'vuex';

// Components
import ProfileLayout from '@layout/ProfileLayout.vue';
import ProfileSidebar from '@components/profile/ProfileSidebar.vue';

/**
 * Component used to show the user profile settings page with different tabs
 */
export default {
  name: 'PersonalArea',
  components: {
    ProfileLayout,
    ProfileSidebar
  },
  data() {
    return {
      oldUser: {},
      newUser: {},
      currentClientRole: 'admin'
    };
  },
  computed: {
    ...mapGetters({
      user: 'user/getUser'
    }),
    activeTab() {
      // Map route names to tab keys
      const routeToTabMap = {
        'personal-information': 'personal_information',
        'account-security': 'account_security',
        'billing-payments': 'billing_payments',
        teams: 'teams',
        'media-library': 'media_library'
      };

      return routeToTabMap[this.$route.name] || 'personal_information';
    }
  },
  async created() {
    const { id, role } = this.user;
    const userResource = await UserApi.getUser({ id, role });

    if (userResource.statusCode === 200) {
      this.newUser = JSON.parse(JSON.stringify(userResource.data.user));
      this.oldUser = JSON.parse(JSON.stringify(userResource.data.user));
      this.currentClientRole = userResource.data.user.sub_client_role;
    }
  },
  methods: {
    /**
     * Method used to update user information
     */
    updateUserInfo(updatedUser) {
      const { id } = this.user;
      // Create a merged user object with the updated data
      const mergedUser = { ...this.newUser, ...updatedUser };
      delete mergedUser.status;

      // Update the user in the API
      UserApi.updateUser({ id, payload: mergedUser })
        .then(response => {
          if (response.statusCode === 200) {
            // Update the store - ensure UI updates immediately
            this.$store.dispatch('user/setUserData', {
              user: mergedUser
            });

            // Force an update of the in-memory user data for immediate UI refresh
            // This ensures changes are visible immediately without requiring logout/login
            if (window.userRefreshCallback) {
              window.userRefreshCallback();
            }

            // Update local state
            this.newUser = mergedUser;
            this.oldUser = JSON.parse(JSON.stringify(mergedUser));

            // Show success notification
            this.$store.dispatch('notification/addSuccessNotification', this.$t('USER_UPDATED'));
          }
        })
        .catch(error => {
          console.error('Error updating user:', error);
          this.$store.dispatch('notification/addErrorNotification', this.$t('ERROR_UPDATING_USER'));
        });
    }
  }
};
</script>

<style lang="scss" scoped>
/* Optimized for performance */
</style>
